/**
 * Aug 7, 2026 — Recently viewed products fix for NPP / default product templates.
 * Theme's T4SThemeSP.recentlyViewed() can leave #recently_wrap stuck on .t4s-loading--bg
 * when localStorage is gated, fetch redirects (NVT_94), or jQuery .data('id') mismatches.
 */
(function ($) {
  'use strict';

  if (!$) return;

  function hideRecentlyViewed($wrap) {
    var $section = $wrap.closest('.id_recently_viewed');
    if ($section.length) {
      $section.hide();
    } else {
      $wrap.hide();
    }
    $wrap.find('.t4s-loading--bg').hide();
  }

  function normalizeProductId(raw) {
    if (!raw) return '';
    var id = String(raw).trim();
    if (id === '19041994') return id;
    if (id.indexOf('id:') === 0) return id;
    var digits = id.replace(/\D/g, '');
    return digits ? 'id:' + digits : '';
  }

  function readRecentIds(limit, currentId) {
    var storage;
    try {
      storage = localStorage.getItem('nt_recent');
    } catch (e) {
      return null;
    }
    if (!storage) return [];

    var cur = normalizeProductId(currentId);
    var ids = storage.split(',').map(normalizeProductId).filter(Boolean);
    ids = ids.filter(function (id) {
      return id !== cur && id !== '19041994';
    });
    return ids.slice(0, limit);
  }

  function writeRecent(currentId, limit) {
    var cur = normalizeProductId(currentId);
    if (!cur || cur === '19041994') return;

    try {
      var ids = [];
      var storage = localStorage.getItem('nt_recent');
      if (storage) {
        ids = storage.split(',').map(normalizeProductId).filter(Boolean);
      }
      ids = ids.filter(function (id) {
        return id !== cur;
      });
      ids.unshift(cur);
      if (ids.length > limit) ids = ids.slice(0, limit);
      localStorage.setItem('nt_recent', ids.join(','));
    } catch (e) {
      /* storage blocked */
    }
  }

  function enableNativeRecentScroll($wrap) {
    /* QC 2026-08-18 18:40 IST: Flickity preventDefault blocked swipe; native X scroll on NPP mobile. */
    if (!document.querySelector('.npp')) return;
    if (window.matchMedia && !window.matchMedia('(max-width: 767px)').matches) return;

    var el = $wrap.find('.flickityt4s')[0];
    if (!el) return;

    var flkty = el.flickityt4s && el.flickityt4s.flkty;
    if (flkty) {
      try {
        flkty.options.draggable = false;
        if (typeof flkty.unbindDrag === 'function') flkty.unbindDrag();
      } catch (e) {
        /* ignore */
      }
    }

    var vp = el.querySelector('.flickityt4s-viewport') || el;
    if (vp.getAttribute('data-npp-rv-scroll') === '1') return;
    vp.setAttribute('data-npp-rv-scroll', '1');

    function syncDots() {
      var dots = el.querySelectorAll('.flickityt4s-page-dots .dot, .flickityt4s-page-dots li');
      var w = vp.clientWidth || 1;
      var i = Math.round(vp.scrollLeft / w);
      for (var d = 0; d < dots.length; d++) {
        if (d === i) dots[d].classList.add('is-selected');
        else dots[d].classList.remove('is-selected');
      }
    }

    vp.addEventListener('scroll', syncDots, { passive: true });
  }

  function initCarousel($wrap) {
    var el = $wrap.find('.flickityt4s')[0];
    if (el && window.T4SThemeSP && T4SThemeSP.Carousel && !el.flickityt4s) {
      el.flickityt4s = new T4SThemeSP.Carousel(el);
      if (T4SThemeSP.ProductItem && T4SThemeSP.ProductItem.resizeObserver) {
        T4SThemeSP.ProductItem.resizeObserver();
      }
    }
    if ($wrap.find('.t4s-product, .nc-pr-card').length && T4SThemeSP.reinitProductGridItem) {
      T4SThemeSP.reinitProductGridItem();
    }
    window.requestAnimationFrame(function () {
      enableNativeRecentScroll($wrap);
    });
  }

  function parseSectionHtml(html) {
    if (!html || html === 'NVT_94') return '';
    try {
      var parsed = $(html);
      var inner = parsed.html();
      return inner || html;
    } catch (e) {
      return html;
    }
  }

  function hasProducts(html) {
    return /t4s-product|nc-pr-card/.test(html);
  }

  function fetchRecentlyViewed($wrap) {
    var sectionId = $wrap.attr('data-sid');
    var unavailable = $wrap.attr('data-unpr') || 'show';
    var limit = parseInt($wrap.attr('data-limit'), 10) || 8;
    var currentId = $wrap.attr('data-id');

    if (!sectionId) {
      hideRecentlyViewed($wrap);
      return;
    }

    var ids = readRecentIds(limit, currentId);
    writeRecent(currentId, limit);

    if (ids === null) {
      hideRecentlyViewed($wrap);
      return;
    }

    if (!ids.length) {
      hideRecentlyViewed($wrap);
      return;
    }

    var searchBase = (window.T4Sroutes && T4Sroutes.search_url) || '/search';
    var url =
      searchBase +
      '/?section_id=' +
      encodeURIComponent(sectionId) +
      '&type=product&options[unavailable_products]=' +
      encodeURIComponent(unavailable) +
      '&sections_url=' +
      encodeURIComponent(window.location.pathname) +
      '&q=' +
      encodeURIComponent(ids.join(' OR '));

    var timeout = window.setTimeout(function () {
      hideRecentlyViewed($wrap);
    }, 12000);

    function finish(html) {
      window.clearTimeout(timeout);
      var content = parseSectionHtml(html);
      if (!content.trim() || !hasProducts(content)) {
        hideRecentlyViewed($wrap);
        return;
      }
      $wrap.html(content);
      initCarousel($wrap);
    }

    if (window.T4SThemeSP && typeof T4SThemeSP.getToFetchSection === 'function') {
      T4SThemeSP.getToFetchSection(null, 'text', url).then(finish);
      return;
    }

    fetch(url, { headers: { 'Cache-Control': 'no-cache' } })
      .then(function (res) {
        return res.text();
      })
      .then(finish)
      .catch(function () {
        hideRecentlyViewed($wrap);
      });
  }

  function isStuckLoading($wrap) {
    return $wrap.length && $wrap.find('.t4s-loading--bg').length > 0;
  }

  function run() {
    var $wrap = $('#recently_wrap');
    if (!$wrap.length) return;
    fetchRecentlyViewed($wrap);
  }

  $(function () {
    // Run after theme's document.ready handler (interactable.min.js).
    window.setTimeout(run, 100);

    // Retry if theme left the spinner visible.
    window.setTimeout(function () {
      var $wrap = $('#recently_wrap');
      if (isStuckLoading($wrap)) {
        fetchRecentlyViewed($wrap);
      }
    }, 2500);
  });
})(window.jQuery_T4NT || window.jQuery);
